import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import styles from './PromoBadge.module.css';

export const PromoBadge = (props) => {
    const className = clsx(styles.container, {
        [styles.disabled]: props.isDisabled,
        [styles.selected]: props.isSelected,
        [styles.inactive]: props.isInactive,
    });

    return (
        <div className={className} onClick={props.onClick} onKeyPress={props.onClick} tabIndex={'0'}>
            {props.caption}
        </div>
    );
};

PromoBadge.propTypes = {
    caption: PropTypes.string,
    isInactive: PropTypes.bool,
    isSelected: PropTypes.bool,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func,
};
